import React, { FC } from 'react';
import { Space } from 'api/space';
import { SpacesSidebar } from 'components/organisms/projects/project-spaces';
import {
  Sider,
  SiderContent,
} from 'components/pages/project-details/project-spaces/project-spaces.styles';
import { useDistractionFreeMode } from 'hooks/use-distraction-free-mode';

interface SpaceSidebarProps {
  onSpaceAdd: (isPrivate?: boolean | undefined) => false | Space[];
  activeSpaceId: string;
  activeSpaceTabId;
  project;
  projectSpaces;
}

export const SpaceSidebar: FC<SpaceSidebarProps> = (props) => {
  const {
    onSpaceAdd,
    activeSpaceId,
    activeSpaceTabId,
    project,
    projectSpaces,
  } = props;

  const { active: isDistractionFree } = useDistractionFreeMode();

  return (
    <Sider data-test-id="project.spaceslist.sidebar" $hide={isDistractionFree}>
      <SiderContent>
        <SpacesSidebar
          onSpaceAdd={onSpaceAdd}
          activeSpaceId={activeSpaceId}
          activeSpaceTabId={activeSpaceTabId ?? 'new'}
          project={project}
          projectSpaces={projectSpaces}
        />
      </SiderContent>
    </Sider>
  );
};
